import { getUser } from '../selectors/auth';
import { useSelector } from 'react-redux';
export const useCurrentUser = userSelector => useSelector(userSelector || getUser);